module.exports = __webpack_public_path__ + "img/downloadRecBut.a2d2560b.svg";